import axios from 'axios';
import _ from 'lodash';

import {
  initIosProducts,
  initIosRequest,
  errorIosRequest
} from '../actions/subscriptions';
import { store as reduxStore } from '../index';

export const YEARLY_PRODUCT_ID = 'io.cordova.monsyn.yearly';
export const MONTHLY_PRODUCT_ID = 'io.cordova.monsyn.monthly';
export const FOREVER_PRODUCT_ID = 'io.cordova.monsyn.forever';
const VERIFICATION_URL =
  'https://monsyn-receipt-validator.onrender.com/receipt';

export const isIOS = () =>
  window.cordova && window.cordova.platformId == 'ios' ? true : false;

const refreshUI = async () => {
  const { store, ProductType, Platform } = window.CdvPurchase;

  // Redirect to Upgrade
  if (!store.localReceipts || !store.localReceipts[0].nativeData) {
    console.log('Redirect to upgrade');

    reduxStore.dispatch({
      type: initIosProducts,
      payload: null
    });

    if (_.last(_.split(window.location.href, '/')) !== 'upgrade') {
      window.location.href = 'app://localhost/index.html#/upgrade';
    }
  }
};

const verified = async (receipt) => {
  receipt.finish();

  const { store, ProductType, Platform } = window.CdvPurchase;
  const storedReceipt = JSON.parse(localStorage.getItem('receipt'));

  if (!store.localReceipts || !store.localReceipts[0].nativeData) {
    reduxStore.dispatch({
      type: initIosProducts,
      payload: storedReceipt ? storedReceipt : null
    });

    return;
  }

  try {
    reduxStore.dispatch({
      type: initIosRequest
    });

    const receiptResponse = await axios.post(VERIFICATION_URL, {
      receipt: store.localReceipts[0].nativeData.appStoreReceipt
    });

    if (!receiptResponse.data.success) {
      console.log("Can't process receipt data.");
      console.log(receiptResponse.data.error);

      reduxStore.dispatch({
        type: initIosProducts,
        payload: storedReceipt ? storedReceipt : null
      });

      reduxStore.dispatch({
        type: errorIosRequest,
        payload: receiptResponse.data.error ?? 'Error in verification'
      });

      return;
    }

    localStorage.setItem(
      'receipt',
      JSON.stringify(receiptResponse.data.receipt)
    );

    reduxStore.dispatch({
      type: initIosProducts,
      payload: receiptResponse.data.receipt
    });
  } catch (error) {
    console.log("Can't connect to verification server.");
    console.log(error);

    reduxStore.dispatch({
      type: initIosProducts,
      payload: storedReceipt ? storedReceipt : null
    });
  }
};

const approved = async (transaction) => {
  transaction.verify();
};

export const initStore = async () => {
  const { store, ProductType, Platform } = window.CdvPurchase;
  let userInfo = JSON.parse(localStorage.getItem('userInfo'));

  store.register([
    {
      type: ProductType.PAID_SUBSCRIPTION,
      id: YEARLY_PRODUCT_ID,
      platform: Platform.APPLE_APPSTORE
    },
    {
      type: ProductType.PAID_SUBSCRIPTION,
      id: MONTHLY_PRODUCT_ID,
      platform: Platform.APPLE_APPSTORE
    },
    {
      type: ProductType.NON_CONSUMABLE,
      id: FOREVER_PRODUCT_ID,
      platform: Platform.APPLE_APPSTORE
    }
  ]);

  store.when().productUpdated(refreshUI).approved(approved).verified(verified);

  if (userInfo) {
    store.applicationUsername = () => {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return userInfo.email;
    };
  }

  const initResult = await store.initialize([
    {
      platform: Platform.APPLE_APPSTORE,
      options: {
        needAppReceipt: true
      }
    }
  ]);

  if (initResult?.isError) {
    reduxStore.dispatch({
      type: errorIosRequest,
      payload: initResult?.message ?? "Can't initialize store"
    });
  }
};
